/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_AllInputs */

const en_directory_builders_all = /** @type {(inputs: Directory_Builders_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All builders`)
};

const zh_directory_builders_all = /** @type {(inputs: Directory_Builders_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部创作者`)
};

/**
* | output |
* | --- |
* | "All builders" |
*
* @param {Directory_Builders_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_all = /** @type {((inputs?: Directory_Builders_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_all(inputs)
	return zh_directory_builders_all(inputs)
});
export { directory_builders_all as "directory.builders.all" }